import React from 'react';
import { ScrollView, View, StyleSheet, TouchableOpacity } from 'react-native';
import {
    DimensionAware,
    getWindowHeight,
    getWindowWidth,
} from 'react-native-dimension-aware';
import { Flex, Button, Box, Text } from '../../../components/common';
import { FormInput } from '../../../components/form';
import { saveApolloMyTaskPricing } from '../../../appRedux/actions/MyTasks';
import { yupAllFieldsValidation } from '../../../constants/utils';
import { Colors, StyledText } from '../../../theme/Index';
import Modal from 'modal-enhanced-react-native-web';
import { MaterialIcons } from '@expo/vector-icons';

import GlobalMdmFields from '../../../components/GlobalMdmFields';
import { mytaskPricingRules } from '../../../constants/FieldRules';
import {
    RoleType,
    SalesOrgType,
    SystemType,
    DistributionChannelType,
    DivisionType,
    CompanyCodeType,
} from '../../../constants/WorkflowEnums';

import DynamicSelect from '../../../components/DynamicSelect';
import {
    fetchCreateTeamRoleFieldMapping,
    fetchOlympusCreateTeamRoleFieldMapping,
} from '../../../redux/DropDownDatas';
import Loading from '../../../components/Loading';
import FlashMessage from '../../../components/FlashMessage';
import { connect } from 'react-redux';
import MultiColorProgressBar from '../../../components/MultiColorProgressBar';
import {
    getStatusBarData,
    getFunctionalGroupData,
    getStaticRequest,
} from '../../../appRedux/actions';
import FilesList from '../../../components/FilesList';
import idx from 'idx';
import * as moment from 'moment';
import TaskNotes from '../../../components/TaskNotes';

class Page extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            WorkflowId: this.props.location.state.WorkflowId,
            TaskId: this.props.location.state.TaskId,
            reject: false,
            // dropDownDatas: {},
            teamRoleFieldMapping: {},
            formData: { RejectionButton: false },
            formErrors: {},
            selectedFiles: {},
            selectedFilesIds: [],
        };
    }

    componentDidMount() {
        let { state: wf } = this.props.location;
        this.props.getStaticRequest([
            40,
            42,
            43,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            67,
            69,
            76,
            77,
            81,
            84,
            71,
        ]);

        let postJson = {
            workflowId: wf.WorkflowId,
            fuctionalGroup: 'pricing',
        };
        this.props.getStatusBarData(postJson);
        this.props.getFunctionalGroupData(postJson);
        //fetchPricingDropDownData().then((res) => this.setState({ dropDownDatas: res }));
        fetchOlympusCreateTeamRoleFieldMapping().then((resp) => {
            const data = resp;
            this.setState({ teamRoleFieldMapping: data });
        });
    }

    setFormErrors = (errors) => {
        const { formErrors } = this.state;
        this.setState({ formErrors: errors }, () => window.scrollTo(0, 0));
    };

    onFieldChange = (value, e) => {
        const { name } = e.target;
        this.setState(
            {
                formData: {
                    ...this.state.formData,
                    [name]: value,
                },
            },
            () => {
                //remove from formData if TypeId is set to 0 OR ''
                if (name.includes('TypeId') && parseInt(value) === 0) {
                    delete this.state.formData[name];
                }
            }
        );
    };

    handleFormSubmission = (schema) => {
        let {
            functionalGroupDetails: { Customer: globalMdmDetail = {} },
        } = this.props;

        let {
                TaskId,
                WorkflowId,
                formData,
                selectedFilesIds,
                selectedFiles,
            } = this.state,
            castedFormData = {},
            postData = {};

        try {
            const WorkflowTaskModel = {
                TaskId: TaskId,
                UserId: localStorage.getItem('userId'),
                WorkflowId: WorkflowId,
                WorkflowTaskOperationType: !formData['RejectionButton'] ? 1 : 2,
                SystemTypeId:
                    globalMdmDetail.SystemTypeId != '' ? globalMdmDetail.SystemTypeId : 2,
            };

            postData['files'] = selectedFilesIds.map((id) => selectedFiles[id]);

            if (!formData['RejectionButton']) {
                castedFormData = schema.cast(formData);
            } else {
                castedFormData = formData;
            }

            delete castedFormData.RejectionButton;
            postData['formdata'] = {
                WorkflowTaskModel,
                //AdditionalNotes: this.state.formData.additionalNotes,
                ...castedFormData,
            };
            console.log('postdata', postData);

            this.props.saveApolloMyTaskPricing(postData, this.props.history);
            this.setState({ modalVisible: false });
            this.resetForm();
            this.scrollToTop();
        } catch (error) {
            console.log('form validtion error');
        }
    };

    onSubmit = (event, reject, schema) => {
        let { formData, selectedFilesIds, selectedFiles } = this.state;
        let fileErrors = {};
        let errors = false;
        selectedFilesIds.map((id) => {
            if (selectedFiles[id] && selectedFiles[id].DocumentType <= 0) {
                fileErrors[id] = 'Document Type Required for file';
                errors = true;
            }
        });

        this.setState({ fileErrors, isFileErrors: errors }, () =>
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        RejectionButton: reject,
                    },
                },
                () => {
                    yupAllFieldsValidation(
                        this.state.formData,
                        schema,
                        (...rest) => {
                            if (this.state.isFileErrors === false)
                                this.handleFormSubmission(...rest);
                        },
                        this.setFormErrors
                    );
                }
            )
        );
    };

    _renderModalContent = () => (
        <Box
            my={4}
            mx="30%"
            backgroundColor="white"
            borderRadius="4px"
            borderColor="rgba(0, 0, 0, 0.1)">
            <Text my={3} fontWeight="regular" color="lightBlue" fontSize={24} pl={4}>
                Release
            </Text>
            <Box px="0px" pb="22px" justifyContent="center">
                <Box alignItems="center" justifyContent="center">
                    <FormInput
                        label="Notes"
                        multiline
                        numberOfLines={2}
                        maxLength={250}
                        name="AdditionalNotes"
                        type="text"
                        onChange={this.onFieldChange}
                        error={
                            this.state.formErrors
                                ? this.state.formErrors['AdditionalNotes']
                                : null
                        }
                        value={
                            this.state.formData && this.state.formData['AdditionalNotes']
                        }
                        variant={'solid'}
                    />
                </Box>
                <Flex
                    justifyEnd
                    alignCenter
                    alignSelf="flex-end"
                    style={{
                        paddingTop: 15,
                        flexDirection: 'row',
                        alignItems: 'center',
                        paddingLeft: 10,
                        paddingRight: 15,
                        marginTop: 20,
                        marginBottom: 10,
                        marginHorizontal: 25,
                    }}>
                    <Button
                        onPress={(event) => {
                            this.onSubmit(event, false, mytaskPricingRules);
                        }}
                        title="Confirm"
                    />
                    <Button
                        title="Cancel"
                        onPress={() => this.setState({ modalVisible: null })}
                    />
                </Flex>
            </Box>
        </Box>
    );

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    resetForm = () => {
        Object.keys(this.state.formData).map((key) => {
            this.setState({
                formData: {
                    [key]: '',
                },
            });
        });
        Object.keys(this.state.formErrors).map((key) => {
            this.setState({
                formErrors: {
                    [key]: '',
                },
            });
        });
        //restore initial values
        this.setState({
            formData: { RejectionButton: false },
        });
    };

    selectFiles = (events) => {
        event.preventDefault();

        const { selectedFilesIds, selectedFiles } = this.state;
        const id = events.target.files[0].name;

        this.setState({
            selectedFiles: {
                ...selectedFiles,
                [id]: {
                    data: events.target.files[0],
                    DocumentName: events.target.files[0].name,
                    DocumentType: 0,
                },
            },
            selectedFilesIds: [...selectedFilesIds, id],
            filename: events.target.files[0].name,
            fileinputkey: Date.now(),
        });
    };

    removeFile = (id) => {
        event.preventDefault();

        var selectedFilesDict = this.state.selectedFiles;
        var selectedFilesIdsList = this.state.selectedFilesIds;
        // remove the existing state
        delete selectedFilesDict[id];
        selectedFilesIdsList = selectedFilesIdsList.filter((fileid) => fileid !== id);

        this.setState({
            selectedFiles: selectedFilesDict,
            selectedFilesIds: selectedFilesIdsList,
        });
    };

    getDropdownValues = (Id, dropdownList) => {
        let description = '';
        if (Id && dropdownList)
            dropdownList.some((data) => {
                if (data.Id === Id) {
                    description = data.Value + ' : ' + data.Description;
                    return true;
                }
            });
        // if (description.includes('/n') || description.includes(';')) {
        //     console.log('html string');
        // }
        return description;
    };

    render() {
        const {
            width,
            location,
            history: { action },
            functionalGroupDetails: {
                DocumentLocation: files,
                Customer: globalMdmDetail = {},
                Pricing: pricingDetail = null,
                RequestorName,
                TaskNote: Notes = '',
                TaskNoteData,
            },
            statusBarData,
            alert = {},
            TasksStatusByTeamId = null,
            staticData,
        } = this.props;
        const { teamRoleFieldMapping } = this.state;

        const { state } = location;
        let tasknotes = TaskNoteData || [];

        const PricingTeamFields =
            idx(teamRoleFieldMapping, (_) => _.PricingTeamFields) || [];
        const RoleTypeId = globalMdmDetail.RoleTypeId;
        const SystemTypeId = globalMdmDetail.SystemTypeId;
        const allowedFieldList = PricingTeamFields.filter(
            (item) => item.RoleTypeId === RoleTypeId && item.SystemTypeId === SystemTypeId
        );
        let allowedFields = undefined;
        if (allowedFieldList && allowedFieldList.length > 0) {
            allowedFields = allowedFieldList[0].Fields;
        }

        const workflow = {
            ...state,
            isReadOnly:
                TasksStatusByTeamId === null ||
                !(
                    globalMdmDetail.WorkflowStateTypeId === 2 &&
                    TasksStatusByTeamId[8].WorkflowTaskStateTypeId === 2
                ),
        };

        const requestDateUtc = moment(globalMdmDetail.DateOfCreation);
        const localDate = moment(requestDateUtc).local();
        const requestDate = localDate.format('YYYY-MM-DD hh:mm:ss A');

        const inputReadonlyProps = workflow.isReadOnly ? { disabled: true } : null;

        const showFunctionalDetail =
            state.isReadOnly && pricingDetail === null ? { display: 'none' } : null;

        const showButtons = workflow.isReadOnly ? { display: 'none' } : null;
        var isReleased = true;
        for (let i = 0; i < statusBarData.length; i++) {
            let teamstatus = statusBarData[i];
            if (teamstatus.WorkflowTaskStateTypeId === 2) {
                isReleased = false;
                break;
            } else {
                isReleased = true;
            }
        }
        var bgcolor = alert.color || '#FFF';
        if (this.props.fetching) {
            return <Loading />;
        }
        if (this.props.fetchingfnGroupData) {
            return <Loading />;
        }

        const { selectedFilesIds, selectedFiles } = this.state;
        console.log(this.props, this.state);

        return (
            <ScrollView
                keyboardShouldPersistTaps="always"
                style={{
                    backgroundColor: '#EFF3F6',
                    paddingBottom: 75,
                }}>
                <Modal isVisible={this.state.modalVisible}>
                    {this._renderModalContent()}
                </Modal>
                {alert.display && (
                    <FlashMessage
                        bg={{ backgroundColor: bgcolor }}
                        message={alert.message}
                    />
                )}
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between">
                    <Text
                        style={{
                            fontWeight: '500',
                            fontSize: 24,
                            color: Colors.lightBlue,
                            marginTop: 25,
                            marginBottom: 20,
                            paddingLeft: 45,
                        }}>
                        My Tasks - {state.Header}
                    </Text>
                    <Box
                        marginTop="25px"
                        flex={3 / 4}
                        flexDirection="row-reverse"
                        alignItems="flex-end">
                        <MultiColorProgressBar readings={statusBarData} />
                    </Box>
                </Box>
                <Box marginTop="25px" flexDirection="row-reverse" alignItems="flex-end">
                    <StyledText
                        style={{
                            fontWeight: '600',
                            paddingRight: '20px',
                            fontSize: '16px',
                            color: '#11307D',
                        }}>
                        {' '}
                        Requestor : {RequestorName}{' '}
                    </StyledText>
                </Box>
                <Box flexDirection="row-reverse" alignItems="flex-end">
                    <StyledText
                        style={{
                            fontWeight: '600',
                            paddingRight: '20px',
                            fontSize: '16px',
                            color: '#11307D',
                        }}>
                        {' '}
                        Date of Request: {requestDate}{' '}
                    </StyledText>
                </Box>
                <View
                    style={{
                        flex: 1,
                        paddingHorizontal: width < 1440 ? 60 : width * 0.1,
                        paddingBottom: 10,
                    }}>
                    <Box fullHeight my={2}>
                        <Box flexDirection="row" justifyContent="space-around" my={4}>
                            <FormInput
                                px="25px"
                                flex={1 / 4}
                                label="WorkflowTitle"
                                maxLength={40}
                                name="WorkflowTitle"
                                variant="outline"
                                type="text"
                                value={globalMdmDetail && globalMdmDetail.WorkflowTitle}
                            />
                            <FormInput
                                px="25px"
                                flex={1 / 4}
                                label="Workflow Number"
                                name="workflow-number"
                                variant="outline"
                                type="text"
                                value={globalMdmDetail && globalMdmDetail.WorkflowId}
                            />
                            <FormInput
                                px="25px"
                                flex={1 / 4}
                                label="Customer Number"
                                name="CustomerNumber"
                                variant="outline"
                                type="text"
                                value={globalMdmDetail && globalMdmDetail.SystemRecordId}
                            />

                            {globalMdmDetail &&
                            globalMdmDetail.MdmCustomerId &&
                            isReleased ? (
                                <TouchableOpacity
                                    onPress={() =>
                                        this.props.history.push(
                                            `/search-results/${globalMdmDetail.MdmCustomerId}`
                                        )
                                    }>
                                    <FormInput
                                        px="25px"
                                        flex={1 / 4}
                                        label="MDM Number"
                                        name="mdm-number"
                                        variant="outline"
                                        type="text"
                                        value={
                                            globalMdmDetail &&
                                            globalMdmDetail.MdmCustomerId
                                        }
                                    />
                                </TouchableOpacity>
                            ) : (
                                <FormInput
                                    px="25px"
                                    flex={1 / 4}
                                    label="MDM Number"
                                    name="mdm-number"
                                    variant="outline"
                                    type="text"
                                    value={
                                        globalMdmDetail && globalMdmDetail.MdmCustomerId
                                    }
                                />
                            )}
                        </Box>
                        {!this.state.isInternationalVersionVisible && (
                            <GlobalMdmFields
                                staticDropDownData={this.props.staticData}
                                formData={globalMdmDetail}
                                viewInternationalModal={() => {
                                    this.setState({
                                        isInternationalVersionVisible: true,
                                    });
                                }}
                                isOlympus={true}
                                readOnly
                            />
                        )}
                        <Text
                            mt="42px"
                            mb="20px"
                            fontWeight="regular"
                            color="lightBlue"
                            fontSize={24}
                            pl={4}>
                            SYSTEM FIELDS
                        </Text>
                        <Box flexDirection="row" justifyContent="center">
                            <Box width={1 / 2} mx="auto" alignItems="center">
                                <FormInput
                                    label="System"
                                    name="System"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        SystemType[
                                            globalMdmDetail &&
                                                globalMdmDetail.SystemTypeId
                                        ]
                                    }
                                    hide={
                                        allowedFields && !allowedFields.includes('System')
                                    }
                                />
                                <FormInput
                                    label="Role"
                                    name="Role"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.RoleTypeId,
                                            staticData && staticData.OlympusRoleType
                                        )
                                    }
                                    hide={
                                        allowedFields && !allowedFields.includes('Role')
                                    }
                                />
                                <FormInput
                                    label="Sales Org"
                                    name="SalesOrg"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.SalesOrgTypeId,
                                            staticData && staticData.OlympusSalesOrgType
                                        )
                                    }
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('SalesOrg')
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="URI/Service Code"
                                    name="URIServiceCode"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('ServiceCode')
                                    }
                                    value={
                                        globalMdmDetail && globalMdmDetail.URIServiceCode
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Delivery Information"
                                    name="UnloadingPoints"
                                    type="text"
                                    value={
                                        globalMdmDetail && globalMdmDetail.UnloadingPoints
                                    }
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('DeliveryInformation')
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Tax Number 4"
                                    name="TaxNumber4"
                                    type="text"
                                    value={globalMdmDetail && globalMdmDetail.TaxNumber4}
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('TaxNumber4')
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Sales District"
                                    name="SalesDistrictTypeId"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('SalesDistrict')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.SalesDistrictTypeId,
                                            staticData &&
                                                staticData.OlympusSalesDistrictType
                                        )
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Sales Office"
                                    name="SalesOffice"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('SalesOffice')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.SalesOfficeTypeId,
                                            staticData &&
                                                staticData.OlympusSalesOfficeType
                                        )
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Sales Group"
                                    name="SalesGroup"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('SalesGroup')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.SalesGroupTypeId,
                                            staticData && staticData.OlympusSalesGroupType
                                        )
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Incoterms 1"
                                    name="Incoterms1"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('Incoterms1')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.IncoTermsTypeId,
                                            staticData && staticData.OlympusIncoTermsType
                                        )
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Place of Destination"
                                    name="PlaceOfDestination"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('PlaceOfDestination')
                                    }
                                    value={
                                        globalMdmDetail &&
                                        globalMdmDetail.PlaceOfDestination
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Acct Assignment Group"
                                    name="AcctAssignmentGroupTypeId"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('AcctAssignmentGroup')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.AcctAssignmentGroupTypeId,
                                            staticData &&
                                                staticData.OlympusAcctAssignmentGroupType
                                        )
                                    }
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Tax Classification"
                                    name="TaxClassification"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('TaxClassification')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.TaxClassificationTypeId,
                                            staticData &&
                                                staticData.OlympusTaxClassificationType
                                        )
                                    }
                                    // value={globalMdmDetail.TaxClassificationTypeId}
                                />
                                <FormInput
                                    inline
                                    variant="outline"
                                    label="Customer Number"
                                    name="CustomerNumber"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('CustomerNumber')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        globalMdmDetail.CustomerNumber
                                    }
                                />
                            </Box>
                            <Box width={1 / 2} mx="auto" alignItems="center">
                                <FormInput
                                    label="Distribution Channel"
                                    name="DistributionChannel"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.DistributionChannelTypeId,
                                            staticData &&
                                                staticData.OlympusDistributionChannelType
                                        )
                                    }
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('DistributionChannel')
                                    }
                                />
                                <FormInput
                                    label="Division"
                                    name="DivisionTypeId"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.DivisionTypeId,
                                            staticData && staticData.OlympusDivisionType
                                        )
                                    }
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('Division')
                                    }
                                />
                                <FormInput
                                    label="CompanyCode"
                                    name="CompanyCodeTypeId"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.CompanyCodeTypeId,
                                            staticData &&
                                                staticData.OlympusCompanyCodeType
                                        )
                                    }
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('CompanyCode')
                                    }
                                />
                                <FormInput
                                    label="Sold To"
                                    name="SoldTo"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('SoldTo') &&
                                        globalMdmDetail &&
                                        globalMdmDetail.RoleTypeId !== 2 &&
                                        globalMdmDetail.RoleTypeId !== 3 &&
                                        globalMdmDetail.RoleTypeId !== 4
                                    }
                                    value={globalMdmDetail && globalMdmDetail.SoldTo}
                                />
                                <FormInput
                                    label="Language"
                                    name="Language"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.LanguageTypeId,
                                            staticData && staticData.OlympusLanguageType
                                        )
                                    }
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('Language')
                                    }
                                />
                                <FormInput
                                    label="Customer Class"
                                    name="CustomerClass"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('CustomerClass')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.CustomerClassTypeId,
                                            staticData &&
                                                staticData.OlympusCustomerClassType
                                        )
                                    }
                                />
                                <FormInput
                                    label="URI Type"
                                    name="UriTypeId"
                                    // inputProps={isSalesForce}
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.URITypeId,
                                            this.props.staticData &&
                                                this.props.staticData.OlympusURIType
                                        )
                                    }
                                    formErrors={
                                        this.state.formErrors
                                            ? this.state.formErrors['UriTypeId']
                                            : null
                                    }
                                    onFieldChange={this.onFieldChange}
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('URIType')
                                    }
                                    variant="outline"
                                    readOnly={true}
                                    inline
                                />
                                <FormInput
                                    variant="outline"
                                    label="Price Group"
                                    name="PriceGroup"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.PriceGroupTypeId,
                                            staticData && staticData.OlympusPriceGroupType
                                        )
                                    }
                                    formErrors={
                                        this.state.formErrors
                                            ? this.state.formErrors['PriceGroup']
                                            : null
                                    }
                                    onFieldChange={this.onFieldChange}
                                    inline={true}
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('PriceGroup')
                                    }
                                />
                                <FormInput
                                    variant="outline"
                                    label="Delivering Plant"
                                    name="DeliveringPlant"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.DeliveringPlantTypeId,
                                            staticData &&
                                                staticData.OlympusDeliveringPlantType
                                        )
                                    }
                                    formErrors={
                                        this.state.formErrors
                                            ? this.state.formErrors['DeliveringPlant']
                                            : null
                                    }
                                    onFieldChange={this.onFieldChange}
                                    inline={true}
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('DeliveringPlant')
                                    }
                                />
                                <FormInput
                                    label="Recon Account"
                                    name="ReconAccount"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('ReconAccount')
                                    }
                                    // value={
                                    //     globalMdmDetail.ReconAccountTypeId != undefined &&
                                    //     this.props.staticData.OlympusReconAccountType !=
                                    //         undefined
                                    //         ? this.props.staticData
                                    //               .OlympusReconAccountType[
                                    //               globalMdmDetail.ReconAccountTypeId
                                    //           ].Description
                                    //         : globalMdmDetail &&
                                    //           globalMdmDetail.ReconAccountTypeId
                                    // }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.ReconAccountTypeId,
                                            staticData &&
                                                staticData.OlympusReconAccountType
                                        )
                                    }
                                />
                                <FormInput
                                    label="Terms of Payment"
                                    name="TermsofPayment"
                                    team="system"
                                    inline={false}
                                    variant="outline"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('TermsOfPayment')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.TermsOfPaymentTypeId,
                                            staticData &&
                                                staticData.OlympusTermsOfPaymentType
                                        )
                                    }
                                />
                                <FormInput
                                    label="Currency"
                                    name="Currency"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('Currency')
                                    }
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.CurrencyTypeId,
                                            staticData && staticData.OlympusCurrencyType
                                        )
                                    }
                                />
                                <FormInput
                                    label="Primary GPO"
                                    name="PrimaryGPO"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('PrimaryGPO')
                                    }
                                    value={globalMdmDetail && globalMdmDetail.PrimaryGPO}
                                />

                                <FormInput
                                    label="Requested Credit Limit"
                                    name="RequestedCreditLimit"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('RequestedCreditLimit')
                                    }
                                    value={
                                        globalMdmDetail &&
                                        globalMdmDetail.RequestedCreditLimit
                                    }
                                />
                                <FormInput
                                    label="Priority"
                                    name="Priority"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        staticData &&
                                        globalMdmDetail &&
                                        this.getDropdownValues(
                                            globalMdmDetail.PriorityTypeId,
                                            staticData && staticData.OlympusPriorityType
                                        )
                                    }
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('Priority')
                                    }
                                />
                                <FormInput
                                    label="Effective Date"
                                    name="EffectiveDate"
                                    team="system"
                                    inline
                                    variant="outline"
                                    type="text"
                                    value={
                                        globalMdmDetail && globalMdmDetail.EffectiveDate
                                    }
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('EffectiveDate')
                                    }
                                />

                                <FormInput
                                    label="Purpose of Request"
                                    name="Purpose"
                                    value={globalMdmDetail && globalMdmDetail.Purpose}
                                    multiline
                                    numberOfLines={
                                        globalMdmDetail.Purpose &&
                                        globalMdmDetail.Purpose.length > 36
                                            ? 3
                                            : 1
                                    }
                                    style={{ lineHeight: '2.5' }}
                                    inline
                                    variant="outline"
                                    maxLength={1000}
                                    type="text"
                                    hide={
                                        allowedFields &&
                                        !allowedFields.includes('PurposeOfRequest')
                                    }
                                />
                            </Box>
                        </Box>

                        {/* <Box {...showFunctionalDetail}>
                            <Text
                                mt="42px"
                                mb="20px"
                                fontWeight="regular"
                                color="lightBlue"
                                fontSize={24}
                                pl={4}>
                                PRICING FIELDS
                            </Text>
                            <Box flexDirection="row" justifyContent="center">
                                <Box width={1 / 2} mx="auto" alignItems="center">
                                    <DynamicSelect
                                        arrayOfData={
                                            this.props.staticData &&
                                            this.props.staticData.OlympusPriceGroupType
                                        }
                                        label="Price Group"
                                        name="PriceGroupTypeId"
                                        hide={
                                            allowedFields &&
                                            !allowedFields.includes('PriceGroup')
                                        }
                                        formErrors={
                                            this.state.formErrors
                                                ? this.state.formErrors[
                                                      'PriceGroupTypeId'
                                                  ]
                                                : null
                                        }
                                        onFieldChange={this.onFieldChange}
                                        value={
                                            workflow.isReadOnly
                                                ? pricingDetail &&
                                                  parseInt(pricingDetail.PriceGroupTypeId)
                                                : this.state.formData
                                                ? this.state.formData['PriceGroupTypeId']
                                                : null
                                        }
                                        inputProps={inputReadonlyProps}
                                        required={true}
                                    />
                                </Box>
                                <Box width={1 / 2} mx="auto" alignItems="center"></Box>
                            </Box>
                        </Box> */}
                    </Box>
                    {files && <FilesList files={files} readOnly />}
                    {workflow.isReadOnly ? (
                        <>
                            <Box my={4}>
                                <Box flexDirection="row" justifyContent="center">
                                    <Box width={1 / 2} mx="auto" alignItems="center">
                                        <FormInput
                                            label="Notes"
                                            multiline
                                            numberOfLines={2}
                                            inputWidth="100%"
                                            name="additionalNotes"
                                            variant="solid"
                                            type="text"
                                            error={
                                                this.state.formErrors
                                                    ? this.state.formErrors[
                                                          'additionalNotes'
                                                      ]
                                                    : null
                                            }
                                            value={
                                                workflow.isReadOnly
                                                    ? Notes
                                                    : this.state.formData
                                                    ? this.state.formData[
                                                          'AdditionalNotes'
                                                      ]
                                                    : null
                                            }
                                            variant={
                                                workflow.isReadOnly ? 'outline' : 'solid'
                                            }
                                            inline={workflow.isReadOnly ? true : false}
                                            hide={
                                                allowedFields &&
                                                !allowedFields.includes('AdditionalNotes')
                                            }
                                        />
                                    </Box>

                                    <Box
                                        width={1 / 2}
                                        mx="auto"
                                        alignItems="center"></Box>
                                </Box>
                            </Box>
                        </>
                    ) : (
                        <FilesList
                            title="NEW ATTACHMENTS"
                            formErrors={this.state.fileErrors}
                            files={selectedFilesIds.map((id) => selectedFiles[id])}
                            onChange={(value, id) => {
                                this.setState({
                                    selectedFiles: {
                                        ...selectedFiles,
                                        [id]: {
                                            ...selectedFiles[id],
                                            DocumentType: parseInt(value),
                                        },
                                    },
                                });
                            }}
                            onRemove={(value, id) => this.removeFile(id)}
                        />
                    )}

                    <Box flexDirection="row" justifyContent="center">
                        <Box ml="5%" width={1 / 2}>
                            {tasknotes && tasknotes.length > 0 && (
                                <TaskNotes taskNotes={tasknotes} />
                            )}
                        </Box>
                        <Box width={1 / 2} mx="auto" alignItems="center" />
                    </Box>
                    <Box {...showButtons}>
                        <Flex
                            justifyEnd
                            alignCenter
                            style={{
                                paddingTop: 15,
                                flexDirection: 'row',
                                alignItems: 'center',
                                paddingLeft: 10,
                                paddingRight: 15,
                                marginTop: 20,
                                marginBottom: 10,
                                marginHorizontal: 25,
                            }}>
                            <label htmlFor="file-upload" className="custom-file-upload">
                                <MaterialIcons
                                    name="attach-file"
                                    size={18}
                                    color="#fff"
                                />
                            </label>
                            <input
                                id="file-upload"
                                key={this.state.fileinputkey}
                                type="file"
                                onChange={this.selectFiles}
                                multiple
                            />
                            <Button
                                onPress={() =>
                                    this.setState({
                                        isReject: false,
                                        modalVisible: true,
                                    })
                                }
                                title="Release"
                            />
                        </Flex>
                    </Box>
                    {this.state.isInternationalVersionVisible && (
                        <Modal
                            isVisible={this.state.isInternationalVersionVisible}
                            style={{ background: '#FFFFFF' }}>
                            <GlobalMdmFields
                                staticDropDownData={this.props.staticData}
                                formData={globalMdmDetail}
                                isInternationalVersion={true}
                                isOlympus={true}
                                isOlympusModal={true}
                                viewInternationalModal={() => {
                                    this.setState({
                                        isInternationalVersionVisible: false,
                                    });
                                }}
                                readOnly
                            />
                        </Modal>
                    )}
                </View>
            </ScrollView>
        );
    }
}

class Default extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;

        return (
            <DimensionAware
                render={(dimensions) => (
                    <Page
                        {...{
                            ...props,
                            width: getWindowWidth(dimensions),
                            height: getWindowHeight(dimensions),
                            marginBottom: 25,
                        }}
                    />
                )}
            />
        );
    }
}

const mapStateToProps = ({ workflows, myTasks, staticData }) => {
    const { fetching, alert } = myTasks;
    const {
        fetchingfnGroupData,
        statusBarData,
        functionalGroupDetails,
        TasksStatusByTeamId,
        fetchingStatusBar,
    } = workflows;
    const { data, fetching: staticFetching } = staticData;
    return {
        fetching: fetching || staticFetching || fetchingStatusBar || fetchingfnGroupData,
        alert,
        statusBarData,
        functionalGroupDetails,
        TasksStatusByTeamId,
        staticData: data,
    };
};

export default connect(mapStateToProps, {
    saveApolloMyTaskPricing,
    getFunctionalGroupData,
    getStatusBarData,
    getStaticRequest,
})(Default);

const styles = StyleSheet.create({
    progressIndicator: {
        flex: 1,
        paddingBottom: 5,
        flexDirection: 'row-reverse',
        alignItems: 'flex-end',
    },
    statusText: {
        fontSize: 15,
        color: '#1D4289',
        fontFamily: 'Poppins',
        textAlign: 'center',
        marginTop: 20,
    },
});
